import React, { useState } from "react"
import CIcon from '@coreui/icons-react'
import {
  CCard, CCardHeader, CCol, CRow,
  CTooltip, CAlert, CContainer, CButton
} from '@coreui/react'
import Notify from "../../utils/Notify"
import ConfirmationModal from "../modals/ConfirmationModal"
import AddVerseModal from "../modals/AddVerseModal"
import { fs } from "../../firebase"
import firebase from "firebase"

export default function VerseItems(props) {
  const book = props.book
  const bookRef = props.bookRef
  const chapter = props.chapter
  const verses = props.chapter.verses.sort((a, b) => a.number - b.number)

  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [showAddVerse, setShowAddVerse] = useState(false)
  const [selectedVerse, setSelectedVerse] = useState()

  function addToVerseOfTheDay(verse) {
    if (!verse) return
    try {
      fs.collection('versesOfDay')
        .doc(`${book.number.toString()}_${chapter.number.toString()}_${verse.number.toString()}`)
        .set({
          book: book.number,
          chapter: chapter.number,
          verse: verse.number,
          createdAt: firebase.firestore.Timestamp.now()
        })
        .then(() => {
          Notify.success('Set as Verse of the day successfully.')
        })
        .catch(error => {
          throw error
        })
    } catch (error) {
      console.log(error)
      Notify.error('Something went wrong, Please try again')
    }
  }

  async function deleteVerse() {
    if (!selectedVerse) return
    try {
      chapter.verses = chapter.verses.filter(item => {
        if (item.number != selectedVerse.number)
          return item
      })

      book.chapters = book.chapters.map(item => {
        if (item.number == chapter.number) {
          return chapter
        } else {
          return item
        }
      })

      await bookRef.doc(book.number.toString()).set(book)
      setShowConfirmModal(false)
      setSelectedVerse(null)
      Notify.success('Verse deleted successfully.')
    } catch (error) {
      console.log(error)
      setShowConfirmModal(false)
      Notify.error('Something went wrong, please try again.')
    }
  }

  return (
    <>
      <CCol className="col-12 col-sm-12 col-md-7 col-xl-7">
        <CRow className="mb-3">
          <CCol>
            <h5>Verses</h5>
          </CCol>
          <CCol className="text-right">
            <CButton color="dark" variant="outline" size="sm"
              shape="pill"
              onClick={() => {
                //setSelectedVerse(null)
                setShowAddVerse(true)
              }}
            >
              <CIcon name="cil-plus" size="sm" />
            </CButton>
          </CCol>
        </CRow>
        <CContainer className="items-scroll-container">
          {
            verses.map(verse => {
              return (
                <CRow>
                  <CCol className="col-10">
                    <CCard className={` mb-2 cursor-pointer`}>
                      <CCardHeader>
                        <CRow>
                          <CCol>
                            <p className="inline-block mb-0`">
                              #{verse.number} {verse.content}
                            </p>
                          </CCol>
                        </CRow>
                      </CCardHeader>
                    </CCard>
                  </CCol>
                  <CCol className="col-2">
                    <CTooltip content="Edit Verse" placement="bottom" >
                      <CIcon style={{ color: '#636f83' }} name={'cilPenAlt'}
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectedVerse(verse)
                          setShowAddVerse(true)
                        }}
                      />
                    </CTooltip>
                    <CTooltip content="Set as Verse of the Day" placement="bottom" >
                      <CIcon style={{ color: '#2eb85c' }} name={'cilPlus'}
                        className="cursor-pointer ml-3"
                        onClick={() => {
                          addToVerseOfTheDay(verse)
                        }}
                      />
                    </CTooltip>
                    <CTooltip content="Delete Verse" placement="bottom" >
                      <CIcon style={{ color: '#e55353' }} name={'cilTrash'}
                        className="cursor-pointer ml-3"
                        onClick={() => {
                          setSelectedVerse(verse)
                          setShowConfirmModal(true)
                        }}
                      />
                    </CTooltip>
                  </CCol>
                </CRow>
              )
            })
          }
        </CContainer>
      </CCol>

      {
        showAddVerse &&
        <AddVerseModal
          show={showAddVerse}
          verse={selectedVerse}
          chapter={chapter}
          book={book}
          bookRef={bookRef}
          onClose={() => {
            setSelectedVerse(null)
            setShowAddVerse(false)
          }}
        />
      }

      {
        showConfirmModal &&
        (
          <ConfirmationModal
            show={showConfirmModal}
            title={`Confirm delete "Verse ${selectedVerse.number}"?`}
            content={() =>
            (
              <>
                <CAlert color="warning" className="w-100">
                  Doing so will permanently delete this Verse.
                </CAlert>
              </>
            )
            }
            onClose={() => {
              setSelectedVerse(null)
              setShowConfirmModal(false)
            }}
            confirmText='Delete'
            onConfirm={() => {
              deleteVerse()
            }}
          />
        )
      }
    </>
  )
}